import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Menu = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M4 12C4 11.4477 4.44772 11 5 11H33C33.5523 11 34 11.4477 34 12C34 12.5523 33.5523 13 33 13H5C4.44772 13 4 12.5523 4 12ZM4 20C4 19.4477 4.44772 19 5 19H36C36.5523 19 37 19.4477 37 20C37 20.5523 36.5523 21 36 21H5C4.44772 21 4 20.5523 4 20ZM4 28C4 27.4477 4.44772 27 5 27H31C31.5523 27 32 27.4477 32 28C32 28.5523 31.5523 29 31 29H5C4.44772 29 4 28.5523 4 28Z"
                 fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Menu;
